import React from 'react';
import RoutableSitecoreLink from '@hedinbil/hedin-ui/dist/utils/RoutableSitecoreLink';

export const SampleCarContactView = ({ carData }) => {
  return (
    <>
      <p>Hitta närmaste anläggning nedan eller kontakta oss via formuläret</p>
      <div className="h-mt-5">
        <h2 className="text-uppercase">{carData?.title}</h2>
      </div>
      <div className="h-mt-5">
        <RoutableSitecoreLink to="/anlaggningar" className="button button--icon">
          Hitta anläggning
        </RoutableSitecoreLink>
      </div>
    </>
  );
};
